var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',{attrs:{"title":_vm.titlePage,"noSteps":""}},[_c('template',{slot:"description"},[_c('div',[_vm._v("Выбор визита • Просмотр термограмм")])]),_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }